export const DESIGNS_CREATE_REMIX_REQUEST = "API/ASSETS/DESIGNS/CREATE_REMIX";
export const DESIGNS_CREATE_REMIX_REQUEST_SUCCESS =
  "API/ASSETS/DESIGNS/CREATE_REMIX_SUCCESS";
export const DESIGNS_CREATE_REMIX_REQUEST_FAILURE =
  "API/ASSETS/DESIGNS/CREATE_REMIX_FAILURE";
